import { Platform } from "@src/mobile/utils/platform";

export type StatusBarStyle = "Dark" | "Light" | "Default";

/**
 * Sets the iOS / Android status-bar content style. No-op on web.
 *
 * - `"Dark"` — light content (use over a dark background).
 * - `"Light"` — dark content (use over a light background).
 * - `"Default"` — system default.
 */
export async function setStatusBarStyle(style: StatusBarStyle): Promise<void> {
  if (!Platform.isMobile) {
    return;
  }

  const { StatusBar, Style } = await import("@capacitor/status-bar");
  await StatusBar.setStyle({ style: Style[style] });
}
